module.exports = __webpack_public_path__ + "img/numbervideo.f27ca0f0.png";